class RadarAddress {
    latitude: number;
    longitude: number;
    city: string;
    postalCode: string;
    number: string;
    street: string;
    addressLabel: string;
}

export class ItemAutocomplete {
    label: string;
    value: RadarAddress | any;
}
